import { createI18n } from 'vue-i18n'

import es from './locales/i18n/es.json'
import en from './locales/i18n/en.json'
import gl from './locales/i18n/gl.json'

import {
  getFallbackLocale,
  getInitialLocale
} from './helpers/language/AvailableLanguages'

// TODO: https://lokalise.com/blog/vue-i18n/  &&  https://phrase.com/blog/posts/ultimate-guide-to-vue-localization-with-vue-i18n/

const i18nInstance = createI18n({
  locale: getInitialLocale(),
  fallbackLocale: getFallbackLocale(),
  legacy: false,
  messages: {
    es,
    en,
    gl
  }
})

export default i18nInstance.global

export const newI18n = i18nInstance
